import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../assets/css/pages/categories.css";
import CategoryTreeComponent from "./CategoryTreeComponent";

export default function () {
  const navigate = useNavigate();
  const [categoriesTree, setCategoriesTree] = useState();
  const [categoryId, setCategoryId] = useState();

  useEffect(() => {
    axios.get("all-categories-tree").then(res => {
      setCategoriesTree(res?.data?.categories_tree);
    });
  }, [categoryId])

  const triggerCategoriesLoop = (categoryId) => {
    setCategoryId(categoryId);
  }

  return (
    <>
      <div>
        <div className="d-flex flex-stack mb-5">
          {true && //Show If user is SuperAdmin
            <>
              <button type="button"
                className="btn btn-light-info mr-3"
                data-bs-toggle="tooltip"
                title="Coming Soon"
                onClick={() => { navigate('/categories') }}
              >
                <i className="fas fa-list fs-3 mr-3"></i> Show Categories List
              </button>
              <button type="button"
                className="btn btn-primary"
                data-bs-toggle="tooltip"
                title="Coming Soon"
                onClick={() => { navigate('/categories/create') }}
              >
                <i className="fas fa-plus fs-3 mr-3"></i> Add Category
              </button>
            </>
          }
        </div>
        <div id="categories" className="table tree align-middle table-row-dashed fs-6 gy-5">
          <div className="row thead text-muted pb-2">
            <div className="col-1 fs-7">
              Expand
            </div>
            <div className="col-1 fs-7">
              ID
            </div>
            <div className="col-2 fs-7">
              Name
            </div>
            <div className="col-1 fs-7">
              Attributes Quantity
            </div>
            <div className="col-2 fs-7">
              Category Code
            </div>
            <div className="col-1 fs-7">
              Products Quantity
            </div>
            <div className="col-2 fs-7">
              Status
            </div>
            <div className="col-2 fs-7">
              Actions
            </div>
          </div>
          <div className="tbody">
            {categoriesTree &&
              (categoriesTree.map((category, index) =>

                <CategoryTreeComponent
                  indexCategory={index}
                  category={category}
                  triggerCategoriesLoop={triggerCategoriesLoop}
                />
              ))
            }
            {!categoriesTree &&
              <div className="loading-div fw-bolder text-muted ls-1">
                Loading . . .
              </div>
            }
          </div>

        </div>
      </div>
    </>
  );
}